import DashboardIcon from "@material-ui/icons/Dashboard";
import SettingsIcon from "@material-ui/icons/Settings";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Assessment from "@material-ui/icons/Assessment";
import PeopleAlt from "@material-ui/icons/PeopleAlt";
import AccountBalance from "@material-ui/icons/AccountBalance";
import LocalAtm from "@material-ui/icons/LocalAtm";
import PermContactCalendar from "@material-ui/icons/PermContactCalendar";

const routes = [
  {
    path: "/chapter/home",
    name: "Dashboard",
    icon: DashboardIcon,
    admin: false
  },
  {
    path: "/chapter/financial-report",
    name: "Chapter Financial Report",
    icon: AccountBalance,
    admin: false
  },
  {
    path: "/chapter/analysis-report",
    name: "Chapter Analysis Reports",
    icon: Assessment,
    admin: false
  },
  {
    path: "/chapter/budget",
    name: "Chapter Budget",
    icon: AttachMoney,
    admin: false
  },
  {
    path: "/chapter/member-count",
    name: "Chapter Member Count",
    icon: PeopleAlt,
    admin: false
  },
  {
    path: "/admin/home",
    name: "Dashboard",
    icon: DashboardIcon,
    admin: true
  },
  {
    path: "/admin/financial-report",
    name: "Manage Chapter Financial Reports",
    icon: AccountBalance,
    admin: true
  },
  {
    path: "/admin/analysis-report",
    name: "Global Analysis Reports",
    icon: Assessment,
    admin: true
  },
  {
    path: "/admin/990-reports",
    name: "990 Reports",
    icon: LocalAtm,
    admin: true
  },
  {
    path: "/admin/individual-analysis-report",
    name: "Individual Chapter Analysis Reports",
    icon: PermContactCalendar,
    admin: true
  },
  {
    path: "/admin/settings",
    name: "Admin",
    icon: SettingsIcon,
    admin: true
  }
];

export default routes;
